import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Box,
  List,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";

import "@/components/membership/Dashboard/Dashboard.css";
import "@/components/membership/Dashboard/DashboardComponents/catalistModal.css";
import { useCatalistExport } from "@/components/membership/Dashboard/DashboardComponents/useCatalistExport"; // Import the hook
import Notifications from "@/components/Notifications/Notifications";

export function CustomCatalistExportModal({ handleCustomFields }) {
  const {
    defaultFields,
    open,
    notification,
    setNotification,
    expandedPanels,
    summaryRefs,
    checkedFields,
    checkedCategories,
    format,
    handleClickOpen,
    handleClose,
    handleSavePreferences,
    handleRestorePreferences,
    handleCheckAllFields,
    confirmFields,
    handleCategoryCheckboxClick,
    handleCheckboxChange,
    handleFormatChange,
    handleIconClick,
  } = useCatalistExport({ handleCustomFields });

  return (
    <>
      <Button
        className="siteBlue"
        onClick={handleClickOpen}
        data-testid="open-custom-fields-modal"
      >
        Customize Export Fields
      </Button>
      <Dialog
        onClose={handleClose}
        open={open}
        data-testid="custom-catalist-export"
        sx={{ "& .MuiDialog-container": { height: "90%" } }}
      >
        <DialogTitle className="seiu-modal-header">
          Export Catalist Data
        </DialogTitle>
        <DialogContent dividers>
          <Box
            sx={{ marginBottom: "8px", display: "flex", justifyContent: "end" }}
          >
            <FormControl size="small" sx={{ width: "115px" }}>
              <InputLabel>Download Format</InputLabel>
              <Select
                value={format}
                label="Download Format"
                onChange={handleFormatChange}
              >
                <MenuItem value="csv">CSV</MenuItem>
                <MenuItem value="parquet">Parquet</MenuItem>
                <MenuItem value="tsv">TSV</MenuItem>
                <MenuItem value="xlsx">XLSX</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <Box data-testid="catalist-form">
            {defaultFields &&
              Object.keys(defaultFields).map((categoryKey) => (
                <div key={categoryKey} className="accordion">
                  <div
                    ref={(el) => (summaryRefs.current[categoryKey] = el)}
                    className="accordion-summary"
                  >
                    <div className="summary-content">
                      <input
                        type="checkbox"
                        aria-label={`select-${categoryKey}`}
                        checked={checkedCategories.includes(categoryKey)}
                        onChange={handleCategoryCheckboxClick(categoryKey)}
                      />
                      <span>{categoryKey}</span>
                    </div>
                    <button
                      className="expand-icon-button"
                      onClick={handleIconClick(categoryKey)}
                      aria-expanded={expandedPanels[categoryKey] || false}
                    >
                      <ExpandMoreIcon />
                    </button>
                  </div>
                  {expandedPanels[categoryKey] && (
                    <div className="accordion-details">
                      <List dense>
                        {defaultFields[categoryKey].map((field) => (
                          <div key={field[0]} className="detail-item">
                            <input
                              type="checkbox"
                              aria-label={`select-${field[0]}`}
                              onChange={handleCheckboxChange(
                                field[0],
                                categoryKey
                              )}
                              checked={checkedFields.includes(field[0])}
                            />
                            <span>{field[0]}</span>
                          </div>
                        ))}
                      </List>
                    </div>
                  )}
                </div>
              ))}
          </Box>
        </DialogContent>
        <DialogActions sx={{ padding: "12px" }}>
          <Button className="siteBlueOutlined" onClick={handleCheckAllFields}>
            Select All Fields
          </Button>
          <Button className="siteBlueOutlined" onClick={handleSavePreferences}>
            Save Export Preferences
          </Button>
          <Button
            className="siteBlueOutlined"
            onClick={handleRestorePreferences}
          >
            Restore Export Preferences
          </Button>
          {/* Focus the primary action on open */}
          {/* eslint-disable-next-line jsx-a11y/no-autofocus */}
          <Button autoFocus className="siteBlue" onClick={confirmFields}>
            Done
          </Button>
        </DialogActions>
      </Dialog>

      {!!Object.keys(notification).length && (
        <Notifications
          notification={notification}
          setNotification={setNotification}
        />
      )}
    </>
  );
}
